import { IAdTarget } from 'redux-state/advertisement/types.js';
import { IRepoState } from 'redux-state/rootReducer.js';
import { ILayoutState } from './types.js';

export const getLayoutState = (state: IRepoState): ILayoutState => {
  return state.LAYOUT;
};

export const getLayoutChild =
  <T extends keyof ILayoutState>(f: T) =>
  (state: IRepoState): ILayoutState[T] => {
    const child = getLayoutState(state)[f];
    return child;
  };

export const getJsonLayoutName = (state: IRepoState): string => state.LAYOUT.screen.layout.name;

export const getScreenMeta = (
  state: IRepoState,
): {
  [key: string]: string;
} => state.LAYOUT.screen.metadata;

export const getIsSkiSeason = (state: IRepoState): string | undefined => state.LAYOUT.screen.isSkiSeason;

export const getAdvertisingTargeting = (state: IRepoState): IAdTarget | undefined =>
  state.LAYOUT.screen.advertising.targeting;
